import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    evaluationFilterData: []
}
const EvaluationFilterSlice = createSlice({
    name: 'evalFilterFields',
    initialState,
    reducers: {
        handleEvalFilterData(state, action) {
            state.evaluationFilterData = action.payload
        }
    }
})

export const { handleEvalFilterData } = EvaluationFilterSlice.actions

export default EvaluationFilterSlice.reducer
